module.exports = __webpack_public_path__ + "img/8group-linkvr-icon.3d2d019e.svg";